import React from "react";

import { Text, Heading } from "@telia/teddy";
import cn from "classnames";
import "./AppLinks.less";

interface AppLinksProps {
    className?: string;
    heading?: string;
    body?: string;
    size?: "default" | "large";
}

const AppLinks = ({ className, heading = "Last ned Telia-appen", body, size = "default" }: AppLinksProps) => {
    const imgClassName = cn({ "app-links__img--large": size === "large" });

    return (
        <div className={className}>
            <Heading mb="100" as="h2" variant="title-200">
                {heading}
            </Heading>
            {!!body && (
                <Text mb="100">
                    {body}
                    <br />
                </Text>
            )}
            <div className="app-links__logo-container">
                <a
                    className="app-links__app-store"
                    href="https://apps.apple.com/no/app/telia-norway/id382824774?amp%3Bmt=8&l=nb"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Last ned Telia-appen i App Store"
                >
                    <img
                        alt="App Store"
                        className={imgClassName}
                        src="/shop/assets/img-static/campaign/app-store-button.svg"
                    />
                </a>
                &nbsp;
                <a
                    href="https://play.google.com/store/apps/details?id=mobi.mobiletech.apps.android.netcom"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Last ned Telia-appen i Google Play"
                >
                    <img
                        alt="Google Play"
                        className={imgClassName}
                        src="/shop/assets/img-static/campaign/google-play-button.svg"
                    />
                </a>
            </div>
        </div>
    );
};

export default AppLinks;
